import axios from 'axios';
import React, { useState, useEffect } from 'react'
import Main from '../Main'
import Repos from './Repos';
import BackToService from './BackToService';
import notFound from '../assets/img/undraw_not_found_60pq.png'


function GithubUser() {
    const [query, setQuery] = useState("unknown");
    const [user, setUser] = useState(null);
    const [isResultGet, setIsResultGet] = useState(true);

    const fetchDetails = async () => {
        try {
            const { data } = await axios.get(`https://api.github.com/users/${query}`);
            setUser(data);
            setIsResultGet(true);
        } catch (error) {
            setIsResultGet(false)
        }
    };

    useEffect(() => {
        fetchDetails();
    }, [])

    if (!isResultGet) {
        return (
            <>
                <Main active="service">
                    <div className="main">
                        <section>
                            <div className="container section-title">
                                <h2>GitHub Public User <BackToService /></h2>
                                <div className="row">
                                    <div className="col-8">
                                        <div className="input-group mb-3">
                                            <input type="text" className="form-control" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search Github User" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                            <div className="input-group-append">
                                                <button className="btn btn-primary" type="button" disabled={query ? false : true} onClick={fetchDetails}>Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="card">
                                            <img src={notFound} alt="" style={{ "height": "calc(100vh - 330px)" }} className="img-thumbnail" />
                                            <h4 style={{ "color": "#173b6c", "textAlign": "center" }}>User not found!</h4>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Main>
            </>
        )
    } else {
        return (
            <>
                <Main active="service">
                    <div className="main">
                        <section>
                            <div className="container section-title">
                                <h2>GitHub Public User <BackToService /></h2>
                                <div className="row">
                                    <div className="col-8">
                                        <div className="input-group mb-3">
                                            <input type="text" className="form-control" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search Github User" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                            <div className="input-group-append">
                                                <button className="btn btn-primary" type="button" disabled={query ? false : true} onClick={fetchDetails}>Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="card">
                                            <img src={user ? user.avatar_url : ""} alt="" className="img-thumbnail" />
                                            <div className="card-body" style={{ "position": "relative" }}>
                                                <div className="text-info" style={{ "fontSize": "18px", "fontWeight": "600" }}>{user ? user.name : ""}</div>
                                                <div className="text-primary">{user ? user.location : ""}</div>
                                                <div className="text-primary">{user ? user.bio : ""}</div>
                                                <div className="text-info">
                                                    Available for hire: {user ? user.hireable ? "YES" : "NOPE" : ""}
                                                </div>
                                                <div className="text-info">Followers {user ? user.followers : ""}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8" style={{ "maxHeight": "calc(100vh - 330px)", "overflowY": "auto" }}>
                                        {user ? <Repos repos_url={user.repos_url} /> : null}
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Main>
            </>

        )
    }
}

export default GithubUser
